import { render, staticRenderFns } from "./threadGatewayManage.vue?vue&type=template&id=f55c678c&"
import script from "./threadGatewayManage.vue?vue&type=script&lang=js&"
export * from "./threadGatewayManage.vue?vue&type=script&lang=js&"
import style0 from "./threadGatewayManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports